import React, { useState } from 'react';

const videos = [
  { id: '10suva4MkcySuVzBSkIqp7DohXdF3o8ct', title: 'Wedding Film 1', category: 'video', type: 'video', thumbnail: 'https://drive.google.com/thumbnail?id=10suva4MkcySuVzBSkIqp7DohXdF3o8ct&sz=w800' },
  { id: '1yUYpemN9LPelvJ6NrgfgiTu_E5H50pHO', title: 'Wedding Film 2', category: 'video', type: 'video', thumbnail: 'https://drive.google.com/thumbnail?id=1yUYpemN9LPelvJ6NrgfgiTu_E5H50pHO&sz=w800' },
  { id: '1TfWMNhYsSgskm9OqHF5nakRHDI6WH_yl', title: 'Wedding Film 3', category: 'video', type: 'video', thumbnail: 'https://drive.google.com/thumbnail?id=1TfWMNhYsSgskm9OqHF5nakRHDI6WH_yl&sz=w800' },
];

const Work = () => {
  const [expandedItem, setExpandedItem] = useState(null);
  const [showPasswordPrompt, setShowPasswordPrompt] = useState(false);
  const [pendingVideoId, setPendingVideoId] = useState(null);
  const [passwordInput, setPasswordInput] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const handleVideoClick = (videoId) => {
    setPendingVideoId(videoId);
    setShowPasswordPrompt(true);
    setPasswordInput('');
    setPasswordError('');
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === 'TME@2026') {
      setExpandedItem(pendingVideoId);
      setShowPasswordPrompt(false);
      setPendingVideoId(null);
      setPasswordInput('');
      setPasswordError('');
    } else {
      setPasswordError('Incorrect password. Please try again.');
    }
  };

  const handleClosePassword = () => {
    setShowPasswordPrompt(false);
    setPendingVideoId(null);
    setPasswordInput('');
    setPasswordError('');
  };

  const inputStyle = {
    width: '100%',
    padding: '14px 16px',
    border: '1px solid #e8e8e8',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    outline: 'none',
    fontFamily: 'inherit'
  };

  return (
    <div id="work">
      <div className="container">
        <div className="sixteen columns">
          <div className="section-top">
            <div className="line-dark"></div>
            <h1>our work</h1>
            <div className="subtext-top">Continuously creating daring digital solutions</div>
            <div className="line-dark1"></div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="sixteen columns">
          <div style={{ 
            textAlign: 'center',
            marginBottom: '30px',
            marginTop: '30px'
          }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '700',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              color: '#d4af37',
              margin: '0'
            }}>
              Films
            </h2>
          </div>
        </div>
      </div>

      {/* Password Modal */}
      {showPasswordPrompt && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '32px',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
          }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '20px', color: '#333' }}>Enter Password</h3>
            <p style={{ margin: '0 0 24px', fontSize: '14px', color: '#666' }}>
              This video is password protected. Please enter the password to view.
            </p>
            <form onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                placeholder="Enter password"
                autoFocus
                style={{
                  ...inputStyle,
                  border: passwordError ? '2px solid #f44336' : '2px solid #ddd',
                  marginBottom: '8px'
                }}
              />
              {passwordError && (
                <p style={{ color: '#f44336', fontSize: '13px', margin: '0 0 16px' }}>
                  {passwordError}
                </p>
              )}
              <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
                <button
                  type="submit"
                  style={{
                    flex: 1,
                    padding: '12px',
                    background: '#667eea',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '16px',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  Submit
                </button>
                <button
                  type="button"
                  onClick={handleClosePassword}
                  style={{
                    flex: 1,
                    padding: '12px',
                    background: '#f5f5f5',
                    color: '#333',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '16px',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
        gap: '30px',
        padding: '40px',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {videos.map(item => (
          <div
            key={item.id}
            style={{
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
              background: '#fff',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            }}
          >
            {expandedItem === item.id ? (
              <div style={{ position: 'relative', lineHeight: 0 }}>
                <iframe
                  src={`https://drive.google.com/file/d/${item.id}/preview`}
                  title={item.title}
                  allow="autoplay; fullscreen"
                  allowFullScreen
                  style={{ width: '100%', height: '300px', border: 'none', display: 'block', verticalAlign: 'bottom' }}
                />
                <button
                  onClick={() => setExpandedItem(null)}
                  style={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    background: 'rgba(0,0,0,0.7)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '50%',
                    width: 32,
                    height: 32,
                    cursor: 'pointer',
                    fontSize: 18,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                >✕</button>
              </div>
            ) : (
              <div
                onClick={() => handleVideoClick(item.id)}
                style={{ cursor: 'pointer', position: 'relative' }}
              >
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  style={{
                    width: '100%',
                    height: '260px',
                    objectFit: 'cover',
                    display: 'block'
                  }}
                  onError={(e) => {
                    e.target.src = `https://lh3.googleusercontent.com/d/${item.id.split('id=')[1] || item.id}=w800`;
                  }}
                />
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(0,0,0,0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.5)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.3)'}
                >
                  <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                  }}>
                    <div style={{
                      width: 0,
                      height: 0,
                      borderTop: '16px solid transparent',
                      borderBottom: '16px solid transparent',
                      borderLeft: '28px solid #333',
                      marginLeft: '6px'
                    }} />
                  </div>
                  <div style={{
                    position: 'absolute',
                    top: '16px',
                    left: '16px',
                    fontSize: '20px',
                    color: 'rgba(255,255,255,0.9)'
                  }}>🔒</div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Work;
